export enum ClarityEvents {
  UPDATE_OFFLINE_DATA = 'update_offline_data',
  DOWNLOAD_OFFLINE_DATA = 'download_offline_data',
  DELETE_OFFLINE_DATA = 'delete_offline_data',
  ENTER_OFFLINE_MODE = 'enter_offline_mode',
  ENTER_FALLBACK_ERROR_PAGE = 'enter_fallback_error_page',
  AUTO_ASSETS_VERSION_UPGRADE = 'auto_assets_version_upgrade',
  USER_WAITED_TOO_MUCH_TO_FIRST_LOADING = 'user_waited_too_much_to_first_loading',
  LIST_FILTER_APPLIED_WITH_NAME = 'filtro aberto:',
  ALTER_LIST_TAB_WITH_NAME = 'tab de listagem selecionada:',
  TOGGLE_COLUMN_VISIBILITY_WITH_NAME = 'alterou visibilidade da coluna:',
  FOCUS_ON_CHANGE_ORDER_STATUS_INPUT = 'foco no input de razão de mudança de status do pedido',
  CHANGE_ORDER_STATUS_IN_MODAL = 'mudou status do pedido via modal',
  FOCUS_SEARCH_FILTER_TYPE = 'foco no pesquisar filtro',
  GO_BACK_BREADCRUMB = 'clicou no voltar do breadcrumb',
  CLICKED_SCROLL_TO_TOP = 'clicou no voltar ao topo',
  CHANGED_SECTION_SIDE_BAR = 'mudou seção do sidebar:',
  CLICKED_BRAND_SELECTOR = 'clicou no seletor de marcas',
  CLICKED_HOME_BRAND_SELECTOR = 'clicou no seletor de marcas da home',
  CLICKED_HEADER_BRAND_SELECTOR = 'clicou no seletor de marcas do header',
  CLICKED_BACK_TO_STORE = 'clicou no voltar para a loja',
  CLICKED_EDIT_ORDER_IN_BRAND = 'clicou no editar pedido na marca',
  ORDER_SCREEN_CLICKED_CREATE_ORDER = 'pedido: clicou em criar pedido',
  ORDER_SCREEN_ORDER_CREATED = 'pedido: pedido criado',
  ORDER_SCREEN_CLICKED_FINISH_ORDER = 'pedido: clicou em finalizar pedido',
  ORDER_SATISFACTION_SURVEY_DISPLAYED = 'pedido: exibiu a pesquisa de satisfação',
  ORDER_SATISFACTION_SURVEY_CLICKED = 'pedido: clicou no link da pesquisa de satisfação',
  ORDER_SCREEN_ORDER_FINISHED = 'pedido: pedido finalizado',
  ORDER_SCREEN_CLICKED_ADD_PRODUCT_BY_CODE_TOPBAR = 'pedido: clicou em adicionar produtos por código na top bar',
  ORDER_SCREEN_PRODUCT_ADDED_BY_CODE_TOPBAR = 'pedido: produto adicionado por código na top bar',
  ORDER_SCREEN_CLICKED_ADD_PRODUCT_INLINE = 'pedido: clicou em adicionar produto na tela do pedido',
  ORDER_SCREEN_PRODUCT_ADDED_INLINE = 'pedido: produto adicionado na tela do pedido',
  ORDER_SCREEN_CLICKED_ADMIN_BUTTON = 'pedido: clicou no botão admin',
  ORDER_SCREEN_CLICKED_BARCODE_READER = 'pedido: clicou no leitor de código de barras',
  ORDER_SCREEN_CLICKED_BARCODE_READER_TOPBAR = 'pedido: clicou no leitor de código de barras na top bar',
  ORDER_SCREEN_CLICKED_CONTINUE_TO_NEXT_SECTION = 'pedido: clicou em continuar para a próxima etapa do pedido',
  GLOBAL_SEARCH_OPENED_BY_SHORTCUT = 'busca global: abriu pelo atalho',
  GLOBAL_SEARCH_OPENED_BY_TRIGGER = 'busca global: abriu pelo botão',
  GLOBAL_SEARCH_SEARCHED = 'busca global: buscou',
  GLOBAL_SEARCH_NO_RESULT = 'busca global: busca sem resultado',
  GLOBAL_SEARCH_SELECTED_RESULT_WITH_ENTITY = 'busca global: abriu resultado:',
  GLOBAL_SEARCH_SELECTED_COMMAND_WITH_ID = 'busca global: executou comando:',
  GLOBAL_SEARCH_ADDED_PRODUCT_TO_ORDER = 'busca global: adicionou produto ao pedido',
  GLOBAL_SEARCH_NAVIGATED_TO_LIST_WITH_ENTITY = 'busca global: abriu a listagem completa:',
  GLOBAL_SEARCH_SHOWED_SUGGESTED_CATALOGS = 'busca global: exibiu catálogos sugeridos',
  GLOBAL_SEARCH_SELECTED_SUGGESTED_CATALOG = 'busca global: abriu um catálogo sugerido',
  GLOBAL_SEARCH_CLICKED_BARCODE_READER = 'busca global: clicou no leitor de código de barras',
  CUSTOMER_SCREEN_OPENED_CREATION_MODAL = 'cliente: abriu o modal de criação',
  CUSTOMER_SCREEN_CUSTOMER_CREATED = 'cliente: cliente criado',
  CUSTOMER_SCREEN_EDITED_FIELD_INLINE = 'cliente: editou campo inline no painel',
  CUSTOMER_SCREEN_OPENED_EDIT_MODAL_WITH_SECTION = 'cliente: abriu modal de edição:',
  CUSTOMER_SCREEN_CLICKED_SAVE_EDIT_MODAL_WITH_SECTION = 'cliente: clicou em salvar no modal de edição:',
  TARGET_SCREEN_TARGET_CREATED = 'plano: plano criado',
  TARGET_SCREEN_RAN_ACTION_WITH_TYPE = 'plano: executou a ação:',
  TARGET_SCREEN_REQUESTED_ACTION_IN_MASS_WITH_TYPE = 'plano: pediu a ação em massa:',
  TARGET_SCREEN_INFORMED_LOSS_REASON_WITH_REASON = 'plano: informou o motivo de perda:',
  TARGET_SCREEN_REQUESTED_LOSS_IN_MASS_WITH_REASON = 'plano: pediu fechamento como perdido em massa com o motivo:',
  TARGET_SCREEN_EDITED_ITEM_VALUE = 'plano: editou o valor de um item',
  TARGET_SCREEN_EDITED_ITEM_SHARE = 'plano: editou o percentual de um item',
  TARGET_SCREEN_CLICKED_SAVE_IMPORT_ITEMS = 'plano: clicou em salvar na importação de itens',
  TARGET_SCREEN_SCHEDULED_DATE = 'plano: agendou a data',
  TARGET_SCREEN_REMOVED_SCHEDULED_DATE = 'plano: removeu a data agendada',
  OBJECT_SCREEN_CHANGED_TAB_WITH_NAME = 'objeto: mudou de aba:',
  OBJECT_SCREEN_OPENED_DETAILS_PANEL = 'objeto: abriu o painel de detalhes',
  OBJECT_SCREEN_CLOSED_DETAILS_PANEL = 'objeto: fechou o painel de detalhes',
  OBJECT_SCREEN_EXPANDED_DETAILS_SECTION_WITH_NAME = 'objeto: expandiu a seção do painel:',
  SHELL_NAVIGATED_BY_SIDEBAR_WITH_NAME = 'casca: navegou pelo menu lateral:',
  SHELL_SEARCHED_PRODUCT_BY_CODE_TOPBAR = 'casca: buscou produto por código na top bar',
  SHELL_CLICKED_BARCODE_READER_TOPBAR = 'casca: clicou no leitor de código de barras na top bar',
  HIGHLIGHT_READ_WITH_TITLE = 'destaque: leu:',
  ANNOUNCEMENT_BAR_CLICKED_LEARN_MORE_WITH_TITLE = 'comunicado: clicou em saiba mais:',
}
